import type { ModalComponentProps } from "@/lib/modal";
import { ConfirmationModal } from "@/components/modals/confirmation-modal";
import { useLeaveTeam } from "@/lib/api/teams";
import type { DashboardTenant } from "@/lib/api/types";

export interface LeaveTeamModalProps {
  tenant: DashboardTenant;
}

export function LeaveTeamModal({
  tenant,
  onClose,
}: LeaveTeamModalProps & ModalComponentProps) {
  const leaveTeam = useLeaveTeam();

  const handleLeave = () => {
    leaveTeam.mutate(tenant.id, {
      onSuccess: () => onClose(),
    });
  };

  return (
    <ConfirmationModal
      title="Leave team"
      description={`Are you sure you want to leave ${tenant.name}? You will lose access to all team resources and will need a new invitation to rejoin.`}
      confirmLabel="Leave team"
      pendingLabel="Leaving..."
      onConfirm={handleLeave}
      isPending={leaveTeam.isPending}
      onClose={onClose}
    />
  );
}

LeaveTeamModal.displayName = "LeaveTeamModal";
